import { nextPageToShow } from '../selectors/routing';
import { selectPurchasedPolicies } from '../selectors';
import { pageOrder } from '../constants';
import {
  UPDATE_APPLICATION_LOCALLY,
  UPDATE_APPLICATION_FROM_SERVER,
  INITIAL_APPLICATION_LOAD,
  CLEAR_APPLICATION,
  CLEAR_ALL_DATA,
  SHOW_NEXT_PAGE,
  FATAL_ERROR,
  QUOTEHELP,
  FE_ERROR,
  ERROR,
} from '../actions/application';
import { PAGES } from '../constants';

const navigationMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  const { location, fatalError } = store.getState();

  const isSummaryPage = location.type === PAGES.SUMMARY;

  // if fatal error exists, any navigation action should redirect back to Quote Help screen
  if (Boolean(fatalError)) {
    const isPageAction = Object.values(PAGES)
      .filter((page) => page !== PAGES.QUOTEHELP)
      .includes(action.type);

    if (isPageAction) {
      store.dispatch({ type: QUOTEHELP });
      return result;
    }
  }

  // once a policy is bound, block navigation back to earlier wizard pages so users can't
  // edit old quote data — redirect any such action to the bound confirmation page (PAYMENT)
  const policyBound = selectPurchasedPolicies(store.getState()).length > 0;
  if (policyBound) {
    const isWizardPageAction = pageOrder.includes(action.type) && action.type !== PAGES.PAYMENT;

    if (isWizardPageAction) {
      store.dispatch({ type: PAGES.PAYMENT });
      return result;
    }
  }

  switch (action.type) {
    case UPDATE_APPLICATION_FROM_SERVER:
      if (!isSummaryPage) {
        store.dispatch({ type: nextPageToShow(store.getState()) });
      }
      return result;
    case FATAL_ERROR:
      store.dispatch({ type: QUOTEHELP });
      return result;
    case FE_ERROR:
      store.dispatch({ type: ERROR });
      return result;
    case UPDATE_APPLICATION_LOCALLY:
    case INITIAL_APPLICATION_LOAD:
    case CLEAR_APPLICATION:
    case CLEAR_ALL_DATA:
    case SHOW_NEXT_PAGE:
      store.dispatch({ type: nextPageToShow(store.getState()) });
      return result;
    default:
      return result;
  }
};

export default navigationMiddleware;
